'use client';

import { useSyncExternalStore } from 'react';
import { GOOGLE_PLAY_URL } from '@/lib/constants/app';
import { getReferralCode, subscribeReferralCode } from '@/lib/utils/referralCode';

function getGooglePlayUrl(): string {
  const code = getReferralCode();
  return code
    ? `${GOOGLE_PLAY_URL}&referrer=${encodeURIComponent(`ref=${code}`)}`
    : GOOGLE_PLAY_URL;
}

function getServerGooglePlayUrl(): string {
  return GOOGLE_PLAY_URL;
}

/**
 * Play listing URL carrying the pending referral code as Install Referrer, so the
 * app can credit the inviter after install. Re-reads on referral code changes, so
 * already-mounted header/footer pick up a code saved later (e.g. by /r/[code]).
 */
export function useGooglePlayUrl(): string {
  return useSyncExternalStore(subscribeReferralCode, getGooglePlayUrl, getServerGooglePlayUrl);
}
